import React from 'react'
import { ContentBlockFragment } from '@contentsite/src/graphql/generated/graphql-types'
import { CardVertical, CardVerticalProps } from './card-vertical/card-vertical'
import { BlockList } from '..'
import { Image } from '../../../graphql/generated/graphql-types'
import { cloudflareImageLoader } from '@dustin-web/microsite-components/src/image/cloudflare-loader'

export type CardCTAVerticalBlockProps = CardVerticalProps & {
  footer?: ContentBlockFragment[]
  mainImageUrl?: string
}

export const CardCTAVerticalBlock = (props: CardCTAVerticalBlockProps) => {
  const mainImage = props.mainImageUrl
    ? { url: props.mainImageUrl }
    : props.mainImage
    ? {
        ...props.mainImage,
        url: cloudflareImageLoader({
          src: props.mainImage?.url || '',
          width: 600,
        }),
      }
    : null
  return (
    <div className="u-pb-16 u-h-100">
      <CardVertical
        {...props}
        footerContent={props.footer && <BlockList blocks={props.footer} />}
        mainImage={mainImage as Image}
      />
    </div>
  )
}
